module.exports = __webpack_public_path__ + "4ea348178a31c0f2f1e3e755160d9874.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fonts/Simple-Line-Icons/Simple-Line-Icons.woff2
 ** module id = ./src/styles/fonts/Simple-Line-Icons/Simple-Line-Icons.woff2
 ** module chunks = 0
 **/